export default function uuid(){
    return `ITN${ crypto.getRandomValues(new Uint32Array(4)).join('-') }`;
};



// WEBPACK FOOTER //
// src/client/helpers/uuid.js